module.exports = __webpack_public_path__ + "static/img/animales_34.37fcf5eb.png";